import React from 'react';
import PropTypes from 'prop-types';
import { useCampaignGroupEnabled } from 'modules/campaigns/modules/campaigns-group-form/hooks/useCampaignGroupEnabled';
import { useBudgetValidations } from 'modules/campaigns/modules/common-campaign-form/components/Budget/hooks/useBudgetValidations';
import { useSpendingLimitOptions } from 'modules/campaigns/modules/common-campaign-form/components/Budget/hooks/useSpendingLimitOptions';
import { useCampaignBudgetRestrictions } from 'modules/campaigns/modules/common-campaign-form/components/BudgetSectionSponsored/hooks/useCampaignBudgetRestrictions';
import { withGridCellFormDataProvider } from 'modules/taboola-common-frontend-modules/formData/withGridCellFormDataProvider';
import SimpleCurrencyCellEditor from './SimpleCurrencyCellEditor';

const BudgetCellEditor = props => {
    const isNoneSpendingLimitDisplayed = useSpendingLimitOptions();
    const campaignGroupExtensionEnabled = useCampaignGroupEnabled();
    const { campaignGroup } = useCampaignBudgetRestrictions();
    const { data } = props;
    const validations = useBudgetValidations(data);
    return (
        <SimpleCurrencyCellEditor
            {...props}
            {...validations}
            formFieldDependencies={{ isNoneSpendingLimitDisplayed, campaignGroupExtensionEnabled, campaignGroup }}
        />
    );
};

BudgetCellEditor.propTypes = {
    /** The grid's context object, passed in by the grid */
    context: PropTypes.object,
    /** The row data object */
    data: PropTypes.object,
};

BudgetCellEditor.defeaultProps = {
    data: {
        budget: { spendingLimit: {} },
    },
};

export default withGridCellFormDataProvider(BudgetCellEditor);
